
export const removeJumpKeys = (jumpLocalKeys: any) => {
    if(jumpLocalKeys) {
        jumpLocalKeys.forEach(jumpKey => {
            localStorage.removeItem('reco_'+jumpKey)
            localStorage.removeItem('lastRecoRetrieval_'+jumpKey)
        })
    }
}